/**
 * Load-time entrance for the product hero — title settles in, then the
 * gallery and buy box rise together. Load-time (not scroll-triggered)
 * since this content is always above the fold.
 */
import { motionEnabled } from '@theme/premium-motion';

if (motionEnabled && typeof gsap !== 'undefined') {
  gsap.set(['.flv-product__title', '.flv-product__gallery', '.flv-product__buybox'], { opacity: 0, y: 24 });
  gsap
    .timeline({ defaults: { ease: 'power3.out', duration: 0.7 } })
    .to('.flv-product__title', { opacity: 1, y: 0 })
    .to(['.flv-product__gallery', '.flv-product__buybox'], { opacity: 1, y: 0, stagger: 0.1 }, '-=0.35');
}
